import React, { useState } from 'react';
import { ExpandableSelector } from 'components/UI/V3/ExpandableSelector/ExpandableSelector';
import { ExpandableSelectorList } from 'components/UI/V3/ExpandableSelector/List/ExpandableSelectorList';
import { ExpandableSelectorItem } from 'components/UI/V3/ExpandableSelector/List/ExpandableSelectorItem';
import { getStandardGracePeriodOptions } from 'utils/TimeOptionsUtils';
import styles from './GracePeriodSelector.module.scss';

interface GracePeriodSelectorProps {
    value: number;
    onChange: (value: number) => void;
    className?: string;
}

export const GracePeriodSelector: React.FC<GracePeriodSelectorProps> = ({ value, onChange, className }) => {
    const [expanded, setExpanded] = useState(false);

    const gracePeriodOptions = getStandardGracePeriodOptions();
    const selectedLabel = gracePeriodOptions.find(option => option.value === value)?.label || '0 min';

    const handleOptionSelect = (optionValue: number) => {
        onChange(optionValue);
        setExpanded(false);
    };

    return (
        <ExpandableSelector
            id="grace-period-selector"
            label={selectedLabel}
            expanded={expanded}
            onExpand={() => setExpanded(!expanded)}
            onClickAway={() => setExpanded(false)}
            className={className}
        >
            <ExpandableSelectorList>
                {gracePeriodOptions.map(option => (
                    <ExpandableSelectorItem
                        key={option.value}
                        onClick={() => handleOptionSelect(option.value)}
                        selected={value === option.value}
                    >
                        {option.label}
                    </ExpandableSelectorItem>
                ))}
            </ExpandableSelectorList>
        </ExpandableSelector>
    );
};
